import React from "react";

export default function ToolWorkspacePage({ title, description, onBack }) {
  return (
    <div className="tool-workspace">
      <div className="tool-workspace__panel">
        <div className="tool-workspace__header">
          <div>
            <div className="tool-workspace__eyebrow">Araç Modülü</div>
            <h1 className="tool-workspace__title">{title}</h1>
            <p className="tool-workspace__description">{description}</p>
          </div>

          <button
            type="button"
            className="tool-workspace__back-button"
            onClick={onBack}
          >
            Haritaya Dön
          </button>
        </div>

        <div className="tool-workspace__grid">
          <section className="tool-workspace__card">
            <h2 className="tool-workspace__card-title">Çalışma Alanı</h2>
            <p className="tool-workspace__card-text">
              Bu sayfa hazırlandı. İlgili araç özelliklerini bu alanın içine
              ekleyeceğiz.
            </p>
          </section>

          <section className="tool-workspace__card">
            <h2 className="tool-workspace__card-title">Sonraki Adım</h2>
            <p className="tool-workspace__card-text">
              Bu ekranın form, tablo ve işlem akışlarını ayrı ayrı
              yerleştirebiliriz.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
